import Image from 'next/image'
import styled, { css } from 'styled-components'

import { FlexContainer } from '@/components'

export const FlexContainerNhShape = styled(FlexContainer)<{
  isVisible: boolean
}>`
  max-width: 100vw;
  overflow: hidden;
  width: 100%;
  transition: height 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 200px;
  padding: 0 16px 200px;
  position: relative;
  background-color: ${({ isVisible, theme }) =>
    isVisible ? theme.colors.white : 'transparent'};

  @media (max-height: 750px) {
    gap: 104px;
    padding: 0 16px 104px;
  }

  ${({ isVisible }) =>
    isVisible &&
    css`
      @media (max-width: 791px) {
        gap: 24px;
        padding: 0 16px 48px;
      }
    `}
`
export const ImageWrapper = styled.div<{
  isVisible: boolean
}>`
  position: relative;
  z-index: -1;

  ${({ isVisible }) =>
    !isVisible &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100vh;
    `}

  &::before {
    content: '';
    display: block;
    z-index: -1;

    position: absolute;
    right: 0px;

    width: 100%;
    height: 100%;
    max-height: 300px;

    background: ${({ theme }) => theme.gradient.primary};
    filter: blur(166px);

    @media (max-width: 700px) {
      display: none;
    }
  }

  .icon-scroll {
    width: 40px;
    height: 70px;
    margin-left: -20px;
    margin-top: -35px;
    box-shadow: inset 0 0 0 1px #fff;
    border-radius: 25px;
    position: absolute;
    bottom: 2rem;

    &::before {
      position: absolute;
      left: 50%;
    }

    &::before {
      content: '';
      width: 8px;
      height: 8px;
      background: #fff;
      margin-left: -4px;
      top: 8px;
      border-radius: 4px;
      animation-duration: 1.5s;
      animation-iteration-count: infinite;
      animation-name: scroll;
    }

    @media (max-width: 500px) {
      border-radius: 5px;
      &::before {
        top: auto;
        bottom: 8px;
        animation-name: scrollMobile;
      }
    }
  }

  @keyframes scroll {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(46px);
    }
  }
  @keyframes scrollMobile {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(-46px);
    }
  }
`

export const NatomContainer = styled.div`
  display: inline-block;
  position: absolute;
  opacity: 0;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
  height: 100vh;
  scale: 0;

  &.visible {
    transition: all 1s ease-in-out;
    scale: 1;
    opacity: 1;
    height: auto;
    padding-top: 112px;
    top: 200px;
  }

  &.scaleup {
    transition: all 1.4s ease-out;
  }

  @media (max-height: 750px) {
    &.visible {
      top: 120px;
    }
  }

  @media (max-width: 791px) {
    &.visible {
      top: 32px;
    }
  }
`

export type NhImageProps = {
  offset: number
}

export const NhImage = styled(Image)<NhImageProps>`
  transition: all 1.3s;
  will-change: transform opacity;
  transform: translate(-${(props) => props.offset}px, 0);
`
